import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("jk_admin_jwt")) navigate("/admin/dashboard");
  }, [navigate]);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await axios.post(`${API}/admin/auth/login`, form, { withCredentials: true });
      localStorage.setItem("jk_admin_jwt", r.data.token);
      localStorage.setItem("jk_admin_user", JSON.stringify(r.data.user));
      toast.success("Welcome");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#0f172a] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <div className="font-serif text-white text-4xl tracking-tight">JK Invest</div>
          <div className="mt-2 uppercase tracking-widest2 text-xs text-slate-400">Admin Panel</div>
        </div>
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-white shadow-2xl p-8 rounded-sm space-y-5"
        >
          <label className="block">
            <div className="text-[11px] uppercase tracking-widest2 font-semibold text-slate-500 mb-1.5">Email</div>
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              data-testid="admin-email"
              className="w-full border border-slate-200 rounded px-3 py-2.5 text-sm focus:border-slate-800 outline-none"
              autoComplete="username"
            />
          </label>
          <label className="block">
            <div className="text-[11px] uppercase tracking-widest2 font-semibold text-slate-500 mb-1.5">Password</div>
            <input
              required
              type="password"
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              data-testid="admin-password"
              className="w-full border border-slate-200 rounded px-3 py-2.5 text-sm focus:border-slate-800 outline-none"
              autoComplete="current-password"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-3 bg-slate-900 text-white text-xs uppercase tracking-widest2 hover:bg-slate-700 transition-colors disabled:opacity-60 rounded"
          >
            {loading ? "…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
